import Cookies from 'js-cookie';
import { Redirect } from 'react-router-dom';

import COOKIES_KEY from 'constants/cookies';
import { useLocation } from 'react-router-dom';

const PageGuard = (
  OriginalComponent: <T = unknown>(...args: T[]) => JSX.Element,
) => {
  const { pathname } = useLocation();
  const token = Cookies.get(COOKIES_KEY.TOKEN);
  const jwtToken = Cookies.get(COOKIES_KEY.JWT_TOKEN);

  const MixedComponent = () => {
    if (!token || !jwtToken) {
      return <Redirect to={`/login?next=${pathname}`} />;
    }

    return <OriginalComponent />;
  };

  return MixedComponent;
};

export default PageGuard;
